import { z } from 'zod';
import { ProjectPositionNumberSchema } from '@schuettflix/interfaces';
import { PositionConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/position/position-configuration.ts';

export const PostPositionConfigurationRequestSchema = PositionConfigurationSchema;

export const PostPositionConfigurationResponseSchema = z.object({
    id: z.string().uuid(),
    projectPositionNumber: ProjectPositionNumberSchema,
});

export type PostPositionConfigurationRequest = z.infer<typeof PostPositionConfigurationRequestSchema>;
